import React from 'react';
import Header from './Header';
import LeftSidebar from './LeftSidebar';
import { useSidebar } from '../../context/SidebarContext';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { isCollapsed, isHoverExpanded } = useSidebar();
  const effectiveCollapsed = isCollapsed && !isHoverExpanded;

  return (
    <div className="m-0 min-h-screen font-sans antialiased font-normal text-base leading-default bg-gray-50 dark:bg-slate-900 text-slate-500 dark:text-slate-400">
      <LeftSidebar />
      <main
        className={`ease-soft-in-out relative min-h-screen rounded-xl transition-all duration-200 ${
          effectiveCollapsed ? 'xl:ml-24' : 'xl:ml-68.5'
        } xl:my-4 xl:mr-4 xl:min-h-[calc(100vh-2rem)]`}
      >
        <Header />
        <div className="w-full px-6 py-6 mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
